import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const SidebarContainer = styled.div<{ $isCollapsed: boolean }>`
  height: calc(100vh - 56px);
  width: ${({ $isCollapsed }) => ($isCollapsed ? '64px' : '260px')};
  background-color: #ffffff;
  border-right: 1px solid var(--color-gray-grayMedium);
  display: flex;
  flex-direction: column;
  padding: 24px 8px;

  position: relative;
  z-index: 2;
  overflow-x: visible;
`;

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  li {
    margin: 0;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: inherit;
  flex-shrink: 0;

  & > svg {
    width: 100%;
    height: 100%;
  }
`;

export const StyledCollapseButton = styled.button`
  position: absolute;
  top: 40%;
  right: -12px; /* Half of button width */
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid var(--color-gray-grayBold);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 999;
  color: var(--color-gray-grayBold);
  box-shadow:
    0 2px 4px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);

  &:hover {
    color: var(--color-primaryAction-regular);
    border-color: var(--color-primaryAction-regular);
    background-color: var(--color-gray-grayLight);
  }
`;

export const ChevronWrapper = styled.div<{ $isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-left: auto;
  color: inherit;
  transition: transform 0.3s ease;
  transform: ${({ $isExpanded }) =>
    $isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};

  & > svg {
    width: 100%;
    height: 100%;
  }
`;

export const StyledNavLink = styled(NavLink)<{ $isCollapsed?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  justify-content: flex-start;
  border-radius: 8px;
  color: var(--color-gray-gray);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9375rem;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: var(--color-primaryAction-alpha);
    color: var(--color-primaryAction-regular);
  }

  &.active {
    background-color: var(--color-primaryAction-alpha);
    color: var(--color-primaryAction-regular);
    font-weight: 600;
  }
`;

export const SubNavWrapper = styled.div<{ $isExpanded: boolean }>`
  opacity: ${({ $isExpanded }) => ($isExpanded ? '1' : '0')};
  transition:
    grid-template-rows 0.3s ease-out,
    opacity 0.3s ease-out;
  display: grid;
  grid-template-rows: ${({ $isExpanded }) => ($isExpanded ? '1fr' : '0fr')};
  & .for-animation {
    min-height: 0px;
    transition: visibility 0.3s ease-out;
    visibility: ${({ $isExpanded }) => ($isExpanded ? 'visible' : 'hidden')};
    overflow: hidden;
  }
`;

export const SubNavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0.25rem 0 0.5rem 2rem; /* Adjusted indentation to account for icon */
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const FloatingSubNavList = styled(SubNavList)`
  padding: 0.5rem;
  margin: 0;
  background: white;
  border: 1px solid var(--color-gray-grayMedium);
  border-radius: 8px;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  min-width: 180px;
`;

export const SubNavLink = styled(NavLink)`
  display: block;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  color: var(--color-gray-gray);
  text-decoration: none;
  font-size: 0.875rem;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--color-primaryAction-alpha);
    color: var(--color-primaryAction-regular);
  }

  &.active {
    color: var(--color-primaryAction-regular);
    font-weight: 600;
  }
`;
